import React from 'react';
import { Modal } from 'antd';
import deleteItem from '../../../assets/delete-icon-white.png';
import { NodeCategory } from 'api/useChat';
import { useChatState } from '../state/chatState';

const DeleteDialog: React.FC = () => {
  const {
    state: { dialogs },
    closeRemoveDialog,
    deleteSessionItem,
    deleteProjectItem
  } = useChatState();
  const { remove } = dialogs;

  const renderDialogTitle = () => {
    switch (remove.nodeCategory) {
      case NodeCategory.SESSION:
        return 'Delete Session';
      case NodeCategory.PROJECT:
        return 'Delete Project';
    }
  };
  const handleOk = () => {
    if (remove.nodeCategory === NodeCategory.SESSION) {
      deleteSessionItem(remove.sessionId, remove.updatedAt, remove.projectIndex, remove.sessionIndex, remove.category);
    } else {
      deleteProjectItem(remove.projectIndex, remove.category);
    }
    closeRemoveDialog();
  };

  return (
    <Modal
      title={
        <div className="flex items-center">
          <span className="text-red-600">{renderDialogTitle()}</span>
        </div>
      }
      centered
      maskClosable={false}
      onCancel={closeRemoveDialog}
      okButtonProps={{
        danger: true
      }}
      open={remove.isOpen}
      footer={
        <div className="flex justify-start">
          <button
            className="bg-red-600 text-white px-4 py-2 rounded-md border-none text-sm cursor-pointer"
            onClick={handleOk}
          >
            <img src={deleteItem} alt="delete" className="w-3 h-3 mr-2" />
            Yes, Delete
          </button>
          <button
            className="bg-transparent border-none text-gray-500 px-4 py-2 cursor-pointer text-sm"
            onClick={closeRemoveDialog}
          >
            Cancel
          </button>
        </div>
      }
    >
      <p>
        <strong>Are you sure you want to delete the {remove.nodeCategory} ?</strong>
      </p>
      <p className="text-gray-500 mt-2">All changes will be lost and cannot be undone.</p>
    </Modal>
  );
};

export default DeleteDialog;
